import { render, staticRenderFns } from "./contentUserGroupChangeRoot.vue?vue&type=template&id=63bae7fe&"
import script from "./contentUserGroupChangeRoot.vue?vue&type=script&lang=js&"
export * from "./contentUserGroupChangeRoot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports